import React from 'react';

// Light page header used by every inner page (same look as the old inner pages).
const PageHero: React.FC<{ title: React.ReactNode; lead: React.ReactNode; children?: React.ReactNode }> = ({
  title,
  lead,
  children,
}) => (
  <section className="bg-gradient-to-br from-gray-50 to-white section-padding">
    <div className="container-width">
      <div className="max-w-3xl">
        <h1 className="text-4xl md:text-5xl font-poppins font-bold text-dark-gray mb-6">{title}</h1>
        <p className="text-xl text-gray-600">{lead}</p>
        {children && <div className="mt-6">{children}</div>}
      </div>
    </div>
  </section>
);

export default PageHero;
